import * as React from 'react';
import { useHistory } from 'react-router-dom'
import { useState, useRef, useEffect } from 'react';

import Utils from '../../../helpers/utils';
import Translate from '../translate';

const getTranslateValue = Utils.getTranslateValue;

const Sidebar = (props) => {
    let URLPath = props.URLPath;
    let translate = useRef(null);
    let history = useHistory();
    const ScreenName = {
        ALT0101: getTranslateValue(translate.current, "views.titleText.top"),
        InvoiceManagement: getTranslateValue(translate.current, "views.titleText.invoicemanagement"),
    }
    

    function handleRedirect(path){
        // $('#loadisng').fadeIn('first');
        if(typeof path === 'string' || path instanceof String){
            history.push(path);
        } else {
            history.push('/Home/Index');
        }
    }

    return (
        <div id="left-sidebar" className="left-sidebar">
            <div className="sidebar-scroll">
                <nav className="main-nav">
                    <ul className="main-menu">
                        {/* <!--Home--> */}
                        <li id="ALT0101">
                            <a onClick={handleRedirect.bind(this, URLPath.ALT0101)} >
                                <i className="fa fa-home fa-fw menu-icon"></i><span className="text">{ScreenName.ALT0101} </span>
                            </a>
                        </li>
                        {/* Invoice management */}
                        <li id="invoiceManagement">
                            <a href="#" className="js-sub-menu-toggle">
                                <i className="fas fa-dolly-flatbed"></i><span className="text">{ScreenName.InvoiceManagement}</span>
                                <i className="toggle-icon fa fa-angle-left"></i>
                            </a>
                            <ul className="sub-menu">
                                <li id="ADT0101">
                                    <a onClick={handleRedirect.bind(this, URLPath.ADT0101)} >
                                        <span className="text">{ScreenName.InvoiceManagement}</span>
                                    </a>
                                </li>
                                <li id="ALT0101">
                                    <a onClick={handleRedirect.bind(this)} >
                                        <span className="text">{ScreenName.InvoiceManagement}</span>
                                    </a>
                                </li>
                                <li id="ALT0101">
                                    <a onClick={handleRedirect.bind(this)} >
                                        <span className="text">{ScreenName.InvoiceManagement}</span>
                                    </a>
                                </li>
                            </ul>
                        </li> 
                      
                    </ul>
                </nav>
            </div>
        </div>
    )
}

export default Sidebar;


// WEBPACK FOOTER //
// ./components/common/container/sidebar.jsx